import { type TabsProps } from 'antd'

import { type StatisticsRangePreset } from './types/common'

// Получаем тип одного элемента массива items
type TabItem = NonNullable<TabsProps['items']>[number]

// Теперь проверяем, что ключ ограничен RangeType (если нужно)
// и при необходимости сузить тип key, расширив TabItem:

type StrictTabItem = Omit<TabItem, 'key'> & { key: StatisticsRangePreset }

export const rangeTypesTabsItems: StrictTabItem[] = [
  { key: 'day', label: 'Сегодня' },
  { key: 'week', label: 'Неделя' },
  { key: 'month', label: 'Месяц' },
  { key: 'allTime', label: 'Все время' },
]
